import { IAccessToken, isSameUrls, useConfigurableAction, useShaRouting, useSheshaApplication,useSettingValue } from "@shesha-io/reactjs";
import useThunkReducer from '@/hooks/thunkReducer';
import {
    AUTHORIZATION_HEADER_NAME,
    saveUserToken as saveUserTokenToStorage,
    getAccessToken as getAccessTokenFromStorage,
    getHttpHeaders as getHttpHeadersFromToken,
    removeAccessToken as removeTokenFromStorage,
} from '../../../utils/auth';
import { CONFIGURABLE_ACTIONS_NAME, CONFIGURABLE_ACTIONS_OWNER } from './model';
import { PublicClientApplication, AuthenticationResult } from "@azure/msal-browser";
import { authReducer } from './reducer';
import { IHttpHeaders } from '@/interfaces/accessToken';
import { fetchedUserDataAsyncAction, setAccessTokenAction } from './actions';
import { AUTH_CONTEXT_INITIAL_STATE, IAuthStateContext } from "./contexts";
import { getLocalizationOrDefault } from "../../../utils/localization";
import { getCustomHeaders, getTenantId } from "../../../utils/multitenancy";
import { sessionGetCurrentLoginInfo } from "../../api/session";
import { useLoginUrl } from "@/hooks/useLoginUrl";

import { getUserManager, setupUserManager } from "../../app/providers/open-client-provider";
// import { HOME_CACHE_URL, URL_CHANGE_PASSWORD, URL_HOME_PAGE, URL_LOGIN_PAGE } from '@/shesa-constants';



const openIDUrlSetting: any = { name: 'RSL.CRM.OpenIdSetting.URL', module: 'Rsl.Crm' };
const openIDClientIdSetting: any = { name: 'RSL.CRM.OpenIdSetting.ClientID', module: 'Rsl.Crm' };
const openIDClientSecretSetting: any = { name: 'RSL.CRM.OpenIdSetting.ClientSecret', module: 'Rsl.Crm' };

export interface IExcuteExternalSignInArguments { }

const ASPNET_CORE_CULTURE = '.AspNetCore.Culture';
const GENERIC_ERR_MSG = 'Oops, something went wrong';

export const useExecuteExternalSignIn = () => {

    const { router } = useShaRouting();
    const { backendUrl, httpHeaders } = useSheshaApplication();
    const storedToken = getAccessTokenFromStorage("xDFcxiooPQxazdndDsdRSerWQPlincytLDCarcxVxv");
    
    //try {
            const { value: openIDUrlSettingValue } = useSettingValue<string>(openIDUrlSetting);
            const { value: openIDClientIdSettingValue } = useSettingValue<string>(openIDClientIdSetting);
            const { value: openIDClientSecretSettingValue } = useSettingValue<string>(openIDClientSecretSetting);
            //setup UserManager with settings from configurable settings
            setupUserManager(openIDUrlSettingValue, {client_id: openIDClientIdSettingValue, client_secret: openIDClientSecretSettingValue});    

       // } catch (error) {
        //swallow error
       // console.error("Error setting up UserManager:", error);
    //}
    

    const headersWithoutAuth = { ...(httpHeaders ?? {}) };
    delete headersWithoutAuth[AUTHORIZATION_HEADER_NAME];

    const initialHeaders = { ...headersWithoutAuth, ...getHttpHeadersFromToken(storedToken?.accessToken) };

    const [state, dispatch] = useThunkReducer(authReducer, {
        ...AUTH_CONTEXT_INITIAL_STATE,
        token: storedToken?.accessToken,
        headers: initialHeaders,
    });

    useConfigurableAction<IExcuteExternalSignInArguments>({
        name: CONFIGURABLE_ACTIONS_NAME,
        owner: CONFIGURABLE_ACTIONS_OWNER,
        ownerUid: CONFIGURABLE_ACTIONS_OWNER,
        hasArguments: true,
        executer: (_, actionContext) => handleSSOLogin(actionContext?.form?.data),
    }, []);

    const handleSSOLogin = async (props) => {

        

        try {
            let ssoType = props['sso-type'];
            switch (ssoType) {
                case "microsoft":
                    await handleMicrosoftLogin(props);
                    break;
                case "google":
                    // code block
                    break;
                case "facebook":
                    // code block
                    break;
                case "linkedin":
                    // code block
                    break;
                case "Microsoft":
                case "openid":
                    await handleOpenIdLogin();
                    console.log("onep login handled");
                    break;
                default:
                // code block
            }
        } catch (error) {
            console.error("Login failed:", error);
            throw error;
        }
    };

    const handleMicrosoftLogin = async (formData) => {
        let msalConfig = {
            auth: {
                clientId: `${formData.AzureADClient}`,
                authority: `https://login.microsoftonline.com/${formData.AzureADTenant}`,
                redirectUri: `${formData.AzureADRedirect}`,
                //redirectUri: 'https://rsl-crm-adminportal.azurewebsites.net/settings',
                postLogoutRedirectUri: "",
                navigateToLoginRequestUrl: false,
            },
            cache: {
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: true,
            }
        };
        const loginRequest = {
            scopes: ["User.Read", "profile"],
            prompt: "select_account",
        };

        const instance = new PublicClientApplication(msalConfig);
        await instance.initialize();
        const loginResponse: AuthenticationResult = await instance.loginPopup(loginRequest);

        const idToken = parseJwt(loginResponse.idToken);
        const accessToken = loginResponse.accessToken;

        const authProvider = 'Microsoft';
        const providerKey = idToken.sub;
        const payload = {
            accessToken,
            authProvider,
            providerKey
        };

        externalAuthenticate(payload);
    };

    const handleOpenIdLogin = async () => {

        const userManager = getUserManager();

       

    const user = await userManager.signinPopup();
    //const user = await userManager.signinRedirect();
    //const user = await userManager.signinPopupCallback();
    console.log('User logged in:', user);

    const idToken = parseJwt(user.id_token);
        const accessToken = user.access_token;

        const authProvider = 'OpenId';
        const providerKey = idToken.sub;
        const payload = {
            accessToken,
            authProvider,
            providerKey
        };

    await externalAuthenticate(payload);
    };

    const externalAuthenticate = async (payload) => {
        const apiBaseUrlAuth = `${backendUrl}/api/TokenAuthExternal/ExternalAuthenticate`;
        //const apiBaseUrlAuth = `${backendUrl}/api/TokenAuth/ExternalAuthenticate`;
        const response = await fetch(apiBaseUrlAuth, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                authProvider: payload.authProvider,
                ProviderAccessCode: payload.accessToken,
                ProviderKey: payload.providerKey
            }),
        });

        

        const data = await response.json();

        if (!response.ok)
            throw new Error("Failed to Auth Token");

        if (data) {
            const token = data.success && data.result ? (data.result as IAccessToken) : null;
            if (token && token.accessToken) {
                // save token to the localStorage
                saveUserTokenToStorage(token, "xDFcxiooPQxazdndDsdRSerWQPlincytLDCarcxVxv");

                // save token to the state
                setAccessTokenAction(token.accessToken);

                // get updated state and notify subscribers
                const newState = state;
                // fireHttpHeadersChanged(newState);

                // get new headers and fetch the user info
                const headers = getHttpHeadersFromState(newState, token.accessToken);
                await fetchUserInfoAsync(headers);
            }
        }
    };

    // const fireHttpHeadersChanged = (providedState: IAuthStateContext = state) => {
    //     const headers = getHttpHeadersFromState(providedState);
    //     // onSetRequestHeaders(headers);
    //     // see if we can set headers via framework
    // };

    const getHttpHeadersFromState = (providedState: IAuthStateContext, newToken: string): IHttpHeaders => {
        const headers: IHttpHeaders = { ...httpHeaders };

        headers['Authorization'] = `Bearer ${newToken}`;

        // TODO: move culture and tenant to state and restore from localStorage on start
        headers[ASPNET_CORE_CULTURE] = getLocalizationOrDefault();

        const tenantId = getTenantId();

        if (tenantId) {
            headers['Abp.TenantId'] = getTenantId().toString();
        }

        const additionalHeaders = getCustomHeaders();

        additionalHeaders.forEach(([key, value]) => {
            if (key && value) {
                headers[key] = value?.toString();
            }
        });

        return headers;
    };

    const fetchUserInfoAsync = (headers: IHttpHeaders) =>
        new Promise((resolve, reject) => {
            const error = { message: GENERIC_ERR_MSG };

            sessionGetCurrentLoginInfo({ base: backendUrl, headers })
                .then((response) => {
                    dispatch(fetchedUserDataAsyncAction());
                    if (response.result.user) {
                        //TODO: remove this when we have a proper way to handle the redirect
                        location.replace('/');
                        const rediretMessage = 'Redirecting';
                        reject({ rediretMessage, url: '/' });

                        if (state.requireChangePassword && Boolean('/account/change-password')) {
                            resolve({ payload: response, url: '/account/change-password' });
                        } else {
                            // if we are on the login page - redirect to the returnUrl or home page
                            if (isSameUrls(router.path, 'login')) {
                                const returnUrl = router.query['returnUrl']?.toString();

                                cacheHomeUrl(response.result?.user?.homeUrl || '/');

                                const redirects: string[] = [returnUrl, response.result?.user?.homeUrl, '/', '/'];
                                const redirectUrl = redirects.find((r) => Boolean(r?.trim())); // skip all null/undefined and empty strings

                                resolve({ payload: response, url: redirectUrl });
                            } else {
                                const redirectUrl = response.result?.user?.homeUrl || "/";
                                resolve({ payload: response, url: redirectUrl.toString() });
                            }
                        }
                    } else {
                        const message = 'Not authorized';
                        clearAccessToken();
                        reject({ message, url: loginUrl });
                    }
                })
                .catch((e) => {
                    const message = error.message;
                    reject({ stackTrace: e, message, url: loginUrl });
                });
        });

    const loginUrl = useLoginUrl({ homePageUrl: '/', unauthorizedRedirectUrl: '/login' });

    const cacheHomeUrl = (url: string) => {
        if (url && url !== '/') localStorage.setItem('HXUL_SRFT', url);
    };

    const clearAccessToken = () => {
        removeTokenFromStorage("xDFcxiooPQxazdndDsdRSerWQPlincytLDCarcxVxv");

        dispatch((dispatchThunk) => {
            dispatchThunk(setAccessTokenAction(null));
            // fireHttpHeadersChanged(getState());
        });
    };

    const parseJwt = (token) => {
        try {
            const base64Url = token.split('.')[1]; // Get the payload part of the token
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join('')
            );

            return JSON.parse(jsonPayload); // Returns the decoded payload
        } catch (error) {
            console.error('Error parsing JWT: ', error);
            return null;
        }
    };

};
